import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

import { Navbar, NavLink, Nav } from "react-bootstrap";

// import css
import "./Header.scss";

class Header extends Component {
  state = {
    
  };


  render() {
    return (
      <Fragment>
        <div id="nav_bar">

        
        <div className="section_1">
            <Navbar
              collapseOnSelect
              bg="light"
              variant="light"
              expand="md"
              fixed="top"
            >
              <div className="container-fluid">
                <Navbar.Brand>
                  <Link to="/" onClick={() => this.clickedLogo()}>
                    <img
                      src={`/images/pulse_lab.png`}
                      className="img-fluid d-block logo_style"
                      alt="NJ Asset Management Private Limited"
                    />
                    {/* <p>pulse labs</p> */}
                  </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse
                  id="basic_navbar_nav_home"
                  className="justify-content-end"
                >
                  <Nav className="justify-content-end">
                    <Nav.Item>
                      <NavLink href="#home" className="nav-link view_link">
                        Home
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#about_us" className="nav-link view_link">
                        About Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#products" className="nav-link view_link">
                        Products
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink href="#contact_us" className="nav-link view_link">
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink  href="/terms_conditions"
                target="_blank" className="nav-link view_link">
                        Terms Conditions
                      </NavLink>
                    </Nav.Item>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div>
        </div>
      </Fragment>
    );
  }
}


export default withRouter(Header);

